/* @flow */
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { i18nReducer } from 'react-redux-i18n'
import { reducer as notifications } from 'react-notification-system-redux'

import global from './global'
import scene from './scene'
import shop from './shop'
import activity from './activity'
import order from './order'
import discount from './discount'

const rootReducer = combineReducers({
  router: routerReducer,
  i18n: i18nReducer,
  notifications,
  global,
  scene,
  shop,
  activity,
  order,
  discount
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js